import styled from "styled-components";

const AbsoluteCenter = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default AbsoluteCenter;
